export default {"src":"/_next/static/image/src/assets/images/logo.bc673f9661c102dfacfbc4bc68c09af2.svg","height":42,"width":312};